import { TableCell, TableRow } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/icons/deleteIcon.svg";
import HtmlTooltip from "components/Elements/HtmlTooltip";
import React from "react";
import { useTranslation } from "react-i18next";

const Row = ({ row, classes, onDeleteNote, onEditPart, isReadOnly }) => {
	const { t } = useTranslation();
	return (
		<TableRow>
			<TableCell style={{ width: "170px" }}>{row.qty}</TableCell>
			<TableCell style={{ width: "110px" }}>{row.name}</TableCell>
			<TableCell
				className="note-field"
				style={{ whiteSpace: "unset", maxWidth: "300px" }}
			>
				<HtmlTooltip title={row.description}>
					<p className="max-two-line">{row.description}</p>
				</HtmlTooltip>
			</TableCell>

			<TableCell style={{ width: "80px" }}>
				{!isReadOnly && (
					<p className="new-link" onClick={() => onEditPart(row)}>
						{t("action.edit")}
					</p>
				)}
			</TableCell>
			<TableCell style={{ width: "50px" }}>
				{isReadOnly ? null : (
					<DeleteIcon
						className={classes.deleteIcon}
						onClick={() => onDeleteNote(row.id)}
					/>
				)}
			</TableCell>
		</TableRow>
	);
};

export default Row;
